{
  "name": "taskradar",
  "version": "1.0.7",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -o",
    "build-dev": "ng build --configuration=development",
    "-inactive build-prod": "ng build --configuration=production",
    "copy-demo": "node transfer.js dev demo",
    "copy-prowasser": "node transfer.js dev prowasser",
    "copy-noteradar": "node transfer.js dev noteradar",
    "-inactive copy-prod": "node transfer.js prod"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.2.2",
    "@angular/common": "^20.2.2",
    "@angular/compiler": "^20.2.2",
    "@angular/core": "^20.2.2",
    "@angular/forms": "^20.2.2",
    "@angular/platform-browser": "^20.2.2",
    "@angular/platform-browser-dynamic": "^20.2.2",
    "@angular/router": "^20.2.2",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "bootstrap": "^5.3.8",
    "moment": "^2.30.1",
    "ngx-bootstrap": "^20.0.1",
    "ngx-toastr": "^19.0.0",
    "rxjs": "~7.8.2",
    "sweetalert2": "^11.17.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.2.1",
    "@angular/cli": "^20.2.1",
    "@angular/compiler-cli": "^20.2.2",
    "@types/node": "^24.3.0",
    "cheerio": "^1.0.0-rc.12",
    "node-ssh": "^13.2.1",
    "typescript": "~5.9.2",
    "zip-a-folder": "^3.1.9"
  }
}
